import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import NewsSection from './components/NewsSection';
import TestimonialsSection from './components/TestimonialsSection';
import { useState } from 'react';

export default function HomePage() {
  const [isGenerating, setIsGenerating] = useState(false);

  // 手動觸發文章生成的功能
  const triggerArticleGeneration = async () => {
    if (isGenerating) return;
    
    setIsGenerating(true);
    try {
      const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
      const supabaseKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;
      
      const response = await fetch(
        `${supabaseUrl}/functions/v1/generate-articles-2025`,
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${supabaseKey}`,
            'Content-Type': 'application/json',
          },
        }
      );
      
      if (response.ok) {
        const result = await response.json();
        console.log('2025年文章生成結果:', result);
        
        if (result.success) {
          alert(`✅ 成功生成2025年文章！標題：${result.article.title}`);
          // 重新載入頁面以顯示新文章
          window.location.reload();
        } else {
          alert('⚠️ 2025年文章生成完成，但可能遇到問題。');
        }
      } else {
        const error = await response.text();
        console.error('生成失敗:', error);
        alert('❌ 2025年文章生成失敗，請稍後再試。');
      }
    } catch (error) {
      console.error('觸發2025年文章生成失敗:', error);
      alert('❌ 網路錯誤，請檢查連線後重試。');
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <HeroSection />
      <ServicesSection />
      <NewsSection />
      <TestimonialsSection />
      <Footer />
      
      {/* 手動觸發按鈕 - 僅供管理使用 */}
      <div className="fixed bottom-4 right-4 z-50">
        <button
          onClick={triggerArticleGeneration}
          disabled={isGenerating}
          className={`${
            isGenerating 
              ? 'bg-gray-400 cursor-not-allowed' 
              : 'bg-purple-600 hover:bg-purple-700 cursor-pointer'
          } text-white px-6 py-3 rounded-lg shadow-lg transition-colors text-sm font-medium whitespace-nowrap flex items-center gap-2`}
        >
          {isGenerating ? (
            <>
              <i className="ri-loader-4-line animate-spin"></i>
              生成2025年文章中...
            </>
          ) : (
            <>
              <i className="ri-article-line"></i>
              生成2025年文章
            </>
          )}
        </button>
      </div>
    </div>
  );
}
